module.exports = __webpack_public_path__ + "img/jumbotron-bg.4d8fa733.png";